/**
 * tools
 *  ツールのメッセージ保存や、送信を行う。
 */
import moment from 'moment'
import tools from '../../api/tools'

moment.locale('ja')

export default {
  namespaced: true,

  state: {
    releaseContents: [],
    releaseTexts :[],
    draftTexts :[],
    contentsId :'',
    scrolltalk : ''
  },

  actions: {
    postText ({commit}, data) {
      commit('POST_TEXT', data)
    },
    getText({commit}){
      commit('GET_TEXT')
    },
    updateText({commit}, data){
      commit('UPDATE_TEXT', data)
    },
    deleteText({commit}, data){
      commit('DELETE_TEXT', data)
    },
    changeText({commit}, data){
      commit('CHANGE_TEXT', data)
    },
    readNotification({commit}, data) {
      return tools.readNotification(data)
        .then((d) => {
          return
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
          alert('エラーが発生しました。')
        })
    }
  },

  mutations: {
    'POST_TEXT' (state, data) {
      var jsonData = {}
      jsonData['active'] = data.active
      jsonData['contents'] = data.contents
      jsonData['html_contents'] = data.html_contents
      jsonData['title'] = data.title

      // TODO: actionsにapi通信は書く
      tools.postText(jsonData)
        .then((d) => {
          state.releaseContents = d.data
          state.releaseTexts = []
          state.draftTexts = []
          for (var i = 0; i<d.data.length; i++) {
            if (d.data[i].active == 1) state.releaseTexts.push(d.data[i])
          }            
          for (var i = 0; i<d.data.length; i++) {
            if (d.data[i].active == 2) state.draftTexts.push(d.data[i])
          }
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
          alert('エラーが発生しました。')
        })
    },
    'GET_TEXT' (state) {

      // TODO: actionsにapi通信は書く
      tools.getText()
        .then((d) => {
          state.releaseContents = d.data
          state.releaseTexts = []
          state.draftTexts = []
          for(var i = 0; i<d.data.length; i++){
            if(d.data[i].active == 1) 
              state.releaseTexts.push(d.data[i])
          }            
          for(var i = 0; i<d.data.length; i++){
            if(d.data[i].active == 2) 
              state.draftTexts.push(d.data[i])
          }
        })
        .catch((e) => {
          console.error('e: ' + JSON.stringify(e))
          alert('エラーが発生しました。')
        })
    },
    'UPDATE_TEXT' (state, data){
      tools.updateText(data)
        .then((d) => {
          state.releaseContents = d.data
        })
    },
    'DELETE_TEXT' (state, data) {
      state.contentsID = data.contents_id
      tools.deleteText(state.contentsID)
    },
    'CHANGE_TEXT' (state, data){
      state.releaseTexts = []
      state.draftTexts = []

      // TODO: actionsにapi通信は書く
      tools.changeText(data)
        .then((d) => {
          state.releaseContents = d.data
          for(var i = 0; i<d.data.length; i++) {
            if (d.data[i].active == 1) state.releaseTexts.push(d.data[i])
          }            
          for(var i = 0; i<d.data.length; i++){
            if(d.data[i].active == 2) state.draftTexts.push(d.data[i])
          }
        })
    },
  }
}






// WEBPACK FOOTER //
// ./src/store/modules/tools.js